// extracted by mini-css-extract-plugin
module.exports = {"container":"downloads_links-module--container--3r1fp","downloadPicture":"downloads_links-module--downloadPicture--CFQ-c","link":"downloads_links-module--link--4EAyw"};